import {defineStore} from "pinia";
import {useSessionStorage} from "@vueuse/core";
import {computed} from "vue";

export const useMberStore = defineStore('mber', () => {
    const initMber = {isLgin: false, mberSn: '', mberNm: ''};
    const mberStore = useSessionStorage('mber', initMber);

    const isLgin = computed(() => mberStore.value.isLgin);
    const mberSn = computed(() => mberStore.value.mberSn);
    const mberNm = computed(() => mberStore.value.mberNm);

    const set = ({mberSn, mberNm}) => {
        mberStore.value = {isLgin: true, mberSn, mberNm};
    }

    const clear = () => {
        mberStore.value = initMber;
        const hrmberStore = sessionStorage.getItem('hrmber');
        if (hrmberStore) {
            sessionStorage.removeItem('hrmber');
        }
    }

    return {isLgin, mberSn, mberNm, set, clear};
});
